export default {
    movies: [
        {
            "name": "Avatar",
            "data": "2,847,397,339",
            "extra": "2009"
        },
        {
            "name": "Avengers: Endgame",
            "data": "2,797,501,328",
            "extra": "2019"
        },
        {
            "name": "Titanic",
            "data": "2,187,425,379	",
            "extra": "1997"
        },
        {
            "name": "Star Wars: The Force Awakens",
            "data": "2,068,223,624",
            "extra": "2015"
        },
        {
            "name": "Avengers: Infinity War",
            "data": "2,048,359,754",
            "extra": "2018"
        },
        {
            "name": "Spider-Man: No Way Home",
            "data": "1,901,232,550",
            "extra": "2021"
        },
        {
            "name": "Jurassic World",
            "data": "1,671,537,444",
            "extra": "2015"
        },
        {
            "name": "The Lion King",
            "data": "1,656,943,394",
            "extra": "2019"
        },
        {
            "name": "The Avengers",
            "data": "1,518,812,988",
            "extra": "2012"
        },
        {
            "name": "Furious 7",
            "data": "1,516,045,911",
            "extra": "2015"
        },
        {
            "name": "Frozen II",
            "data": "1,450,026,933",
            "extra": "2019"
        },
        {
            "name": "Avengers: Age of Ultron",
            "data": "1,402,809,540",
            "extra": "2015"
        },
        {
            "name": "Black Panther",
            "data": "1,347,280,838",
            "extra": "2018"
        },
        {
            "name": "Harry Potter and the Deathly Hallows - Part 2",
            "data": "1,342,025,430",
            "extra": "2011"
        },
        {
            "name": "Star Wars: The Last Jedi",
            "data": "1,332,539,889",
            "extra": "2017"
        },
        {
            "name": "Jurassic World: Fallen Kingdom",
            "data": "1,309,484,461",
            "extra": "2018"
        },
        {
            "name": "Frozen",
            "data": "1,290,000,000",
            "extra": "2013"
        },
        {
            "name": "Beauty and the Beast",
            "data": "1,263,521,126",
            "extra": "2017"
        },
        {
            "name": "Incredibles 2",
            "data": "1,242,805,359",
            "extra": "2018"
        },
        {
            "name": "The Fate of the Furious",
            "data": "1,238,764,765",
            "extra": "2017"
        },
        {
            "name": "Iron Man 3",
            "data": "1,214,811,252",
            "extra": "2013"
        },
        {
            "name": "Minions",
            "data": "1,159,398,397",
            "extra": "2015"
        },
        {
            "name": "Captain America: Civil War",
            "data": "1,153,329,473",
            "extra": "2016"
        },
        {
            "name": "Aquaman",
            "data": "1,148,485,886",
            "extra": "2018"
        },
        {
            "name": "The Lord of the Rings: The Return of the King",
            "data": "1,146,030,912",
            "extra": "2003"
        },
        {
            "name": "Spider-Man: Far From Home",
            "data": "1,131,927,996",
            "extra": "2019"
        },
        {
            "name": "Captain Marvel",
            "data": "1,128,274,794",
            "extra": "2019"
        },
        {
            "name": "Transformers: Dark of the Moon",
            "data": "1,123,794,079",
            "extra": "2011"
        },
        {
            "name": "Top Gun: Maverick",
            "data": "1,115,975,367",
            "extra": "2022"
        },
        {
            "name": "Skyfall",
            "data": "1,108,561,013",
            "extra": "2012"
        },
        {
            "name": "Transformers: Age of Extinction",
            "data": "1,104,054,072",
            "extra": "2014"
        },
        {
            "name": "The Dark Knight Rises",
            "data": "1,081,142,612",
            "extra": "2012"
        },
        {
            "name": "Joker",
            "data": "1,074,251,311",
            "extra": "2019"
        },
        {
            "name": "Star Wars: The Rise of Skywalker",
            "data": "1,074,144,248",
            "extra": "2019"
        },
        {
            "name": "Toy Story 4",
            "data": "1,073,394,593",
            "extra": "2019"
        },
        {
            "name": "Toy Story 3",
            "data": "1,066,969,703",
            "extra": "2010"
        },
        {
            "name": "Pirates of the Caribbean: Dead Man's Chest",
            "data": "1,066,179,725",
            "extra": "2006"
        },
        {
            "name": "Rogue One: A Star Wars Story",
            "data": "1,056,057,273",
            "extra": "2016"
        },
        {
            "name": "Aladdin",
            "data": "1,050,693,953",
            "extra": "2019"
        },
        {
            "name": "Pirates of the Caribbean: On Stranger Tides",
            "data": "1,045,713,802",
            "extra": "2011"
        },
        {
            "name": "Despicable Me 3",
            "data": "1,034,799,409",
            "extra": "2017"
        },
        {
            "name": "Jurassic Park",
            "data": "1,034,199,003",
            "extra": "1993"
        },
        {
            "name": "Finding Dory",
            "data": "1,028,570,889",
            "extra": "2016"
        },
        {
            "name": "Star Wars: Episode I - The Phantom Menace",
            "data": "1,027,044,677",
            "extra": "1999"
        },
        {
            "name": "Alice in Wonderland",
            "data": "1,025,467,110",
            "extra": "2010"
        },
        {
            "name": "Zootopia",
            "data": "1,023,784,195",
            "extra": "2016"
        },
        {
            "name": "The Hobbit: An Unexpected Journey",
            "data": "1,017,003,568",
            "extra": "2012"
        },
        {
            "name": "Harry Potter and the Philosopher's Stone",
            "data": "1,006,968,171",
            "extra": "2001"
        },
        {
            "name": "The Dark Knight",
            "data": "1,005,973,645",
            "extra": "2008"
        },
        {
            "name": "Harry Potter and the Deathly Hallows - Part 1",
            "data": "977,043,483",
            "extra": "2010"
        }
    ],
    question: "Which movie grossed more worldwide?"
}